import * as React from "react";
import PdfPrinter from "pdfmake";
import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { ehrActions } from "../../core/actions";
import { useDispatch, useSelector } from "react-redux";
import { jsonSchema } from "../../shared/schema";
import { useOrganization } from "../../configurations/OrganizationContext";
import { PRINT_FILE, PRINT_PREVIEW } from "../../shared/constants";
import { printPDFFile } from "../erp-billing/ERPActions/erpActions";
import {
ORG_CODES
} from "../../shared/constants";

var fonts = require("pdfmake/build/vfs_fonts");

function Pdfprint(props) {
  const org = useOrganization();
  // Print the selected prescription's latest persisted date instead of today.
  const selectedPrescriptionRecords = (props.prescriptionList || []).flatMap(
    (item) => [item, ...(item.combinedEhrPrescriptions || [])]
  );
  const validPrescriptionDates = selectedPrescriptionRecords
    .map((item) => {
      const createdDate = new Date(item?.cdt);
      if (!Number.isNaN(createdDate.getTime())) return createdDate;

      const updatedDate = new Date(item?.udt);
      return Number.isNaN(updatedDate.getTime()) ? null : updatedDate;
    })
    .filter(Boolean);
  const providedPrescriptionDate = new Date(props.prescriptionDate);
  const hasProvidedPrescriptionDate =
    Boolean(props.prescriptionDate) &&
    !Number.isNaN(providedPrescriptionDate.getTime());
  const prescriptionDate = hasProvidedPrescriptionDate
    ? providedPrescriptionDate
    : validPrescriptionDates.length
      ? new Date(
          Math.max(...validPrescriptionDates.map((date) => date.getTime()))
        )
      : new Date();
  const day = prescriptionDate.getDate();
  const month = prescriptionDate.toLocaleString("default", { month: "short" });
  const year = prescriptionDate.getFullYear();
  const suffix = getNumberWithSuffix(day);
  const formattedDate = `${suffix} ${month} ${year}`;
  // const [rowCheck, setRowCheck] = useState();
  const qz = require("qz-tray");
  const [rowCheck, setRowCheck] = useState();
  const printerName = process.env.REACT_APP_PRINTER_NAME;
  const EMERGENCY_CONTACT_NO = process.env.REACT_APP_EMERGENCY_NUNBER;
  const dispatch = useDispatch();
  const [patientInfo, setpatientInfo] = useState(props.selectedPatient);
  const [count, setCount] = useState(0);
  const [doctorDetails, setDoctorDetails] = useState(
    JSON.parse(localStorage.getItem("doctorInformation"))
  );
  const [printerStatus, setPrinterStatus] = useState("Not Connected");
  const [printPreviewType, setPrintPreviewType] = useState(
    props.printPreviewType
  );

  function getNumberWithSuffix(number) {
    const suffixes = ["th", "st", "nd", "rd"];
    const suffix = number % 100;
    return (
      number + (suffixes[(suffix - 20) % 10] || suffixes[suffix] || suffixes[0])
    );
  }

  // Initialize rows for the prescription table
  let rows = [[]];
  rows[0] = [
    { text: "Medication", rowSpan: 2, fontSize: 6, alignment: "center" },
    { text: "Dosage", rowSpan: 2, fontSize: 6, alignment: "center" },
    { text: "Instructions", colSpan: 4, fontSize: 6, alignment: "center" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "Duration", rowSpan: 2, fontSize: 6, alignment: "center" },
    { text: "Comments", rowSpan: 2, fontSize: 6, alignment: "center" },
  ];

  rows.push(
    ["", "", "M", "A", "E", "N", "", ""].map((cell) => ({
      text: cell,
      fontSize: 6,
      alignment: "center",
    }))
  );
  console.log(rows);

  const dd = [];
  let prescArray = [];

  useEffect(() => {
    console.log("props of prescription", props, doctorDetails);
    console.log("patientinfo", props.selectedPatient);
    console.log("props:::pdf::", props.prescriptionList);

    // ✅ LOG 1 — check what's coming in
    console.log("RAW prescriptionList:", JSON.stringify(
      props.prescriptionList?.map(i => ({
        id: i.id,
        combinedEhrPrescriptions: i.combinedEhrPrescriptions?.length,
        notes: i.notes?.substring(0, 50)
      }))
    ));

    // ✅ STEP 1 — expand grouped EHR prescriptions into individual items
    const expandedList = [];
    props.prescriptionList &&
      props.prescriptionList.forEach((item) => {
        if (
          item.combinedEhrPrescriptions &&
          item.combinedEhrPrescriptions.length > 0
        ) {
          expandedList.push(...item.combinedEhrPrescriptions);
        } else {
          expandedList.push(item);
        }
      });

    // ✅ LOG 2 — check expanded list
    console.log("expandedList length:", expandedList.length);
    console.log("expandedList ids:", expandedList.map(i => i.id));

    let currIndex = 0;
    const totalItems = expandedList.length;

    if (totalItems === 0) {
      console.warn("No items to print");
      return;
    }

    // ✅ STEP 2 — process each item
    expandedList.forEach((item, index) => {
      console.log("processing item index:", index, "id:", item.id);
      console.log("item.compositionId:", item.compositionId);
      console.log("indexesss", index);
      console.log("item.compositionId", item.compositionId);

      // Non-EHR org — parse notes JSON directly
      if (!item.compositionId || !props.ehrid || props.ehrid === "") {
        console.log("Non-EHR org: using notes JSON for item", index);
        // ✅ Non-EHR org — parse notes JSON directly, skip EHR fetch
        console.log("Non-EHR org: using notes JSON from procedure for print");
        try {
          const notesJson = JSON.parse(item.notes);
          let localmedicine = "";
          for (let content of notesJson.content) {
            for (let events of content.activities) {
              for (let items of events.description.items) {
                if (items._type === "ELEMENT") {
                  if (items.name.value === "Local medicinal product brand") {
                    localmedicine = items.value.value;
                  }
                }
              }
            }
          }
          jsonSchema
            .getSchemaFromCanonicalJson(
              notesJson,
              notesJson.archetype_details.template_id.value,
              "editComposition"
            )
            .then((form) => {
              form["local medicinal brand"] = localmedicine;
              console.log("pdfprintform non-EHR item", index, form);
              console.log("pdfprintform non-EHR", form);
              formatEpres(form);

              currIndex++;
              console.log("currIndex:", currIndex, "totalItems:", totalItems);

              if (currIndex === totalItems) {
                console.log("all items processed, generating PDF");
                buildRowsAndGenerate();
              }
            })
            .catch((e) => {
              console.error("getSchemaFromCanonicalJson failed", e);
              currIndex++;
              if (currIndex === totalItems) {
                buildRowsAndGenerate();
              }
            });
        } catch (e) {
          console.error("Failed to parse notes JSON for print", e);
          currIndex++;
          if (currIndex === totalItems) {
            buildRowsAndGenerate();
          }
        }
        return;
      }

      // EHR org — normal flow
      dispatch(
        ehrActions.getCompositionByVid(
          {},
          item.compositionId,
          props.ehrid,
          async (resCb) => {
            if (resCb) {
              let localmedicine = "";
              currIndex++;
              for (let content of resCb.content) {
                for (let events of content.activities) {
                  for (let items of events.description.items) {
                    if (items._type === "ELEMENT") {
                      if (items.name.value === "Local medicinal product brand") {
                        localmedicine = items.value.value;
                      }
                    }
                  }
                }
              }
              let form = await jsonSchema.getSchemaFromCanonicalJson(
                resCb,
                resCb.archetype_details.template_id.value,
                "editComposition"
              );
              form["local medicinal brand"] = localmedicine;
              formatEpres(form);
            }
            if (currIndex === totalItems) {
              buildRowsAndGenerate();
            }
          }
        )
      );
    });

    return () => {
      console.log("Entering disconnect");
    };
  }, []);

  // ✅ Separated out so it's called once after ALL items processed
  const buildRowsAndGenerate = () => {
    console.log("buildRowsAndGenerate called, prescArray:", prescArray);
    prescArray.forEach((row) => {
      if (row.rowCheck === true) {
        rows.push(
          [
            row.medicineName,
            row.dosage[0],
            row.M[0],
            row.A[0],
            row.E[0],
            row.N[0],
            row.advicetoDispenser[0],
            row.comment[0],
          ].map((cell) => ({ text: cell, fontSize: 6 }))
        );
      } else {
        rows.push([
          { text: row.medicineName, fontSize: 6 },
          { text: row.dosage[0], fontSize: 6 },
          { text: row.instructions[0], colSpan: 4, fontSize: 6 },
          "",
          "",
          "",
          { text: row.advicetoDispenser[0], fontSize: 6 },
          { text: row.comment[0], fontSize: 6 },
        ]);
      }
    });
    generatePrescriptionPdf();
  };

  const formatEpres = (docPrescArray) => {
    console.log("docPrescArray", docPrescArray);
    console.log("docPrescArrayproperties", docPrescArray.properties);

    let prescObject = docPrescArray.properties;
    let presc = Object.keys(docPrescArray.properties);
    let siNo = 0;
    let medicineName = docPrescArray["local medicinal brand"];
    let dosage = "";
    let instructions = "";
    let advicetoDispenser = "";
    let comment = "";
    let M = "";
    let E = "";
    let A = "";
    let N = "";
    let rowCheck = true;

    presc.map((pre) => {
      console.log("press2", pre);
      siNo = siNo + 1;
      if (pre === "Dose unit") {
        dosage = prescObject[pre].textarea;
        // console.log("instructionssss",instructions);
      }
      if (pre === "Instructions to patient") {
        const split = splitInstructions(prescObject[pre]);
        const rowsCheck = containsOnlyNumericValue(split);
        if (split.length === 4 && rowsCheck === true) {
          console.log("rowCheck");
          M = split[0];
          A = split[1];
          E = split[2];
          N = split[3];
          rowCheck = true;
        } else if (split.length === 1 && split[0] === " ") {
          M = "";
          A = "";
          E = "";
          N = "";
          rowCheck = true;
        } else {
          instructions = prescObject[pre].textarea;
          rowCheck = false;
        }
      }
      if (pre === "Advice to dispenser") {
        advicetoDispenser = prescObject[pre].textarea;
        // console.log("Advice to dispenserss",advicetoDispenser);
      }
      if (pre === "Comment") {
        comment = prescObject[pre].textarea;
        // console.log("commentss",comment)
      }
    });

    prescArray.push({
      medicineName,
      dosage,
      instructions,
      M, A, E, N,
      advicetoDispenser,
      comment,
      rowCheck,
    });
    console.log("prescArray after push:", prescArray);
    console.log("prescArrayprescArray", prescArray);
    // prescArray.forEach((row) => {
    //   console.log("adjdfgfhj",row)
    //   rows.push([row.medicineName, row.instructions[0], row.advicetoDispenser[0], row.comment[0]]);
    // });
    // console.log("prescriptionrowsibsdh", rows);
    // addPrescription();
  };

  function splitInstructions(instruction) {
    console.log("instruction: ", instruction);
    const split = instruction.default.split("-");
    console.log("Instructions: ", split, rows);
    return split;
  }

  function containsOnlyNumericValue(arr) {
    return arr.every((element) => !isNaN(element));
  }

  async function generatePrescriptionPdf() {
    let getDocDefinition;
    if (org?.orgCode === ORG_CODES.MANASWINI) {
      // Manaswini
      getDocDefinition = (await import("../../manaswini/docdefpdfprint")).getDocDefinition;
      console.log("manaswini");
    } else if (org?.orgCode === ORG_CODES.MNH) {
      // MNH
      getDocDefinition = (await import("../../mnh/docdefpdfprint")).getDocDefinition;
      console.log("mnh");
    } else if (org?.orgCode === ORG_CODES.VEDAMAAYU) {
      getDocDefinition = (await import("../../vm/docdefpdfprint")).getDocDefinition;
      console.log("vedamaayu");
    } else {
      console.error("Invalid organization. Cannot load doc definition.");
      return;
    }

    const docDefinition = getDocDefinition({
      rows,
      formattedDate,
      patientInfo,
      EMERGENCY_CONTACT_NO,
      selectedPatient: props.selectedPatient,
    });

    printPrescription(docDefinition);
  }

  function printPrescription(docDefinition) {
    console.log("print previewww", PRINT_PREVIEW);
    console.log("print fileee", PRINT_FILE);
    console.log("print preview typeee", printPreviewType);
    console.log("print fileee", PRINT_FILE);
    //     if (printPreviewType === PRINT_FILE) {
    //       PdfPrinter.createPdf(
    //         docDefinition,
    //         null,
    //         null,
    //         fonts.pdfMake.vfs
    //       ).getBuffer((buffer) => {
    //         console.log("bufferrr", buffer);
    //         const blob = new Blob([buffer], { type: "application/pdf" });
    //         // const url = URL.createObjectURL(blob);
    //         // const a = document.createElement("a");
    //         // a.href = url;
    //         // a.download = `LabReport_${patientInfo.person.name}.pdf`;
    //         // document.body.appendChild(a);
    //         // a.click();
    //         // document.body.removeChild(a);
    //         // Create FormData if using multipart/form-data
    //         const formData = new FormData();
    //         formData.append("file", blob, "invoice.pdf");
    // console.log("print api get called started");

    //         printPDFFile(formData);
    // console.log("print api get called endeddd");

    //       });
    //     } else
    if (printPreviewType === PRINT_PREVIEW || printPreviewType === PRINT_FILE) {
      PdfPrinter.createPdf(docDefinition, null, null, fonts.pdfMake.vfs).open();
      let pdf;
      const pdfDocGenerator = PdfPrinter.createPdf(
        docDefinition, null, null, fonts.pdfMake.vfs
      );
      pdfDocGenerator.getBase64((data) => { pdf = data; });

      //console.log("pdfdocument is", pdfDocGenerator);
      console.log("printer status prop check else case connecting");
      qz.websocket.connect()
        .then(() => {
          console.log("connecting");
          //setPrinterStatus('Connected');
          console.log("connected");
          return qz.printers.find();
        })
        .then((printers) => {
          console.log("The Printers are ", printers);
          console.log("The Printers are ", printerName);
          console.log("The Printers are ", process.env.REACT_APP_ACCOUNTS_URL);

          printers.filter((el) => {
            if (el.includes(printerName)) {
              // if(el.includes('HP DeskJet 1200 series')) {
              // if(el.includes('Canon LBP6030/6040/6018L')) {

              let config = qz.configs.create(el, {
                size: { width: 148, height: 210 },
                units: "mm",
                scaleContent: false,
              });

              console.log("config is", config);
              return qz.print(config, [{
                type: "pixel",
                format: "pdf",
                // pageSize: 'A5',
                // flavor: 'base64',
                flavor: "file",
                data: pdf,
                // data: '<h1>Hello JavaScript!</h1>'
              }]).then(() => {
                console.log("print complete");
                return qz.websocket.disconnect();
                //Promise.resolve('Printing successful');
                // return qz.websocket.disconnect();
              });
            }
          });
        })
        .then(() => {
          qz.websocket.disconnect();
          console.log("Disconnected");
        })
        .catch((err) => {
          console.error("Print error:", err);
        });
    }
  }

  return <></>;
}

export default Pdfprint;
